import Faq from "components/Faq";

export default Faq;



// WEBPACK FOOTER //
// ./src/containers/Faq/index.js